import { Article } from "../../types/article";
import { addArticlesBulk } from "../../services/articles.service";

export function reduceToUniqueArticlesBasedOnField(
  articles: Article[],
  fieldExtractor: (article: Article) => string
): Article[] {
  const seen = new Set<string>();
  return articles.filter((article) => {
    const key = `${fieldExtractor(article)}|${article.parentArticleCombinationNumber ?? ""}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

export async function addUniqueArticlesToGroup(
  articles: Article[],
  groupId: string
): Promise<void> {
  // If article is in combination then we add articlesCountInCombination which hold the quantity in the combination
  const remappedArticles = articles.map((article) => ({
    ...article,
    nbrArticles: article.parentArticleCombinationNumber
      ? (article.articlesCountInCombination ?? 1)
      : 1,
    groupId: groupId,
  }));

  await addArticlesBulk(
    reduceToUniqueArticlesBasedOnField(
      remappedArticles,
      (article) => article.productArticleId
    ),
    groupId
  );
}
